import * as React from "react"
import { createNavigation } from "blog/components/navigation"
import { JSONRenderer } from "blog/components/json_renderer"
import { PostNode } from "blog/json_nodes"
import { createPage } from "blog/page"

export const createPost = (post: PostNode): React.ComponentType<any> => () => {
  const page = createPage(createNavigation(), post)
  return <JSONRenderer json={page} />
}
